<!-- @format -->

<div class="container" *transloco="let t">
  <fudis-heading [class]="'fudis-mt-md'" [level]="1">{{ t("GRADUATION_WIZARD.TITLE") }}</fudis-heading>
  @if (
    {
      step: step$ | async,
      surveyEnabled: surveyEnabled$ | async,
      surveyUrl: surveyUrl$ | async,
      showSurveyStep: showSurveyStep$ | async,
    };
    as progress
  ) {
    <sis-wizard-progress
      [currentStep]="progress.step"
      [stepKeys]="progress.showSurveyStep ? wizardStepKeysAll : wizardStepKeysWithoutSurvey" />
    @if (progress.step === 0) {
      <app-graduation-wizard-step1 [organisationId]="graduationOrgId" [stepNumber]="1" (forward)="next()"></app-graduation-wizard-step1>
    }
    @if (progress.step === 1 && progress.showSurveyStep) {
      <app-graduation-wizard-step2
        [stepNumber]="2"
        [surveyEnabled]="progress.surveyEnabled"
        [surveyUrl]="progress.surveyUrl"
        (back)="previous()"
        (surveyOpened)="openGraduationSurvey()"
        (forward)="next()">
      </app-graduation-wizard-step2>
    }
    @if ((progress.showSurveyStep && progress.step === 2) || (!progress.showSurveyStep && progress.step === 1)) {
      @let profile = profile$ | async;
      @let validatablePlan = validatablePlan$ | async;
      @let degreeProgramme = degreeProgramme$ | async;
      @if (profile && validatablePlan?.plan && degreeProgramme) {
        <app-graduation-wizard-step3
          [degreeProgramme]="degreeProgramme"
          [profile]="profile"
          [plan]="validatablePlan.plan"
          [studyRight]="validatablePlan.studyRight"
          [stepNumber]="progress.showSurveyStep ? 3 : 2"
          (forward)="submitApplication($event)">
        </app-graduation-wizard-step3>
      }
    }
  }
</div>
